<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';

    const props = defineProps<{ class?: HTMLAttributes['class'] }>();
</script>

<template>
    <div
        data-slot="dialog-footer"
        :class="
            cn(
                'sticky bottom-0 flex flex-col-reverse gap-2 rounded-b-lg bg-white p-5 sm:flex-row sm:justify-end',
                props.class,
            )
        "
    >
        <slot />
    </div>
</template>
